import { Suspense, useEffect } from "react";
import { Await, defer, useActionData, useLoaderData, useRevalidator, useSubmit } from "react-router-dom";
import CenteredSpinner from "../../../components/centerVPspinner";
import api from "../../../hooks/useApi";
import { Alert, Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { Autoform } from "../../../components/forms/autoform";
import { Grid, Container, Paper } from '@mui/material';
import DataContext from "../../../hooks/FormsContext";
import jsonToFormData from "../../../hooks/jsonToFormData";
import ErrorBoundary from "../../../components/errorBoundary";
import PageTitle from "../../../components/PageTitle";

const formName = 'HotelLocation';

export async function loader({ params, request }) {
    const id = params.child_object_id;
    const parent_id = params.object_id;
    
    return defer({
        promise: Promise.all(
            [
                api.get(`/api/${formName}/${id}/draft/`),
            ]
        ),
        id: id,
        p_id: parent_id || null,
    });
}

export async function action({ params, request }) {
    const formData = await request.formData();
    const resp = {};
    try {
        const id = params.child_object_id;
        const parent_id = params.object_id;

        const response = await api.patch(`/api/${formName}/${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'  // Set Content-Type
            }
        });

        const children = JSON.parse(sessionStorage.getItem('location'));
        const children_ = children? children : []; 
        const formDataPatch = jsonToFormData({ location: [...children_, id] });
// console.log(({
//             patch_hotel_children: formDataPatch,
//         })
        const patch_response = await api.patch(`/api/HotelLocation/${parent_id}/`, formDataPatch, {
            headers: {
                'Content-Type': 'multipart/form-data'  // Set Content-Type
            }
        })

// console.log(({
//             patch_response,
//         })

        window.opener.postMessage({
            patch_data: { children_obj: response.data.id },
            success: true
        }, '*');
        window.close();
    }
    catch (e) {
//console.log((e);
        resp.success = false;
        resp.error = e;
    }
    return resp;

}

export default function MobileAddLocationObj() {
    const actionData = useActionData();
    const loaderData = useLoaderData();
    const revalidator = useRevalidator();
    const formHook = useForm();
    const submit = useSubmit();

    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post',
            encType: 'multipart/form-data'
        })
    }

    return (
        <Box
            sx={{ my: 8 }}
            className={
                revalidator.state === "loading" ? "loading" : "content"
            }>
            <PageTitle title={`Локація об'єкта (мобільна): ${loaderData?.p_id || "ID"}`} />
            <Suspense
                fallback={<CenteredSpinner />}
            >
                <Await
                    resolve={loaderData.promise}
                    error={<ErrorBoundary/>}
                >
                    {([promise]) => {
                        return (
                            <>
                                <Container>
                                    <Grid item xs={8}>
                                        <Box>
                                            <h2>Додати локацію</h2>
                                            {actionData?.status === false && (
                                                <Alert severity='error'>Сталася помилка! {JSON.stringify(actionData.error)}</Alert>
                                            )}
                                            <DataContext.Provider value={promise.data.forms}>
                                                <Autoform
                                                    fields={promise.data.form}
                                                    formHook={formHook} // Pass the formHook to AutoForm
                                                    formName={formName}
                                                    onSubmit={handleFormSubmit}
                                                    renderChildForm={true}
                                                    revalidator={revalidator}
                                                    patchID={loaderData.id}
                                                    className={'aboba'}
                                                />
                                            </DataContext.Provider>
                                            <Box sx={{my:2}}>
                                                {actionData?.error && (
                                                    <Alert severity='error'>
                                                        <Box>
                                                            Сталася помилка!
                                                        </Box>
                                                        <Box>{JSON.stringify(actionData.error.message)}</Box>
                                                    </Alert>
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Container>
                            </>
                        )
                    }}
                </Await>
            </Suspense>
        </Box>
    )
}
